
    <h1>Welcome to {{personPrefill.OrganizationName}}!</h1>
      <h2>Thank you! Your ${{ totalPayment }} payment
        was successful!</h2>
    <div class="next-page-button">
      <p-button (click)="login()" label="Log into my account"/>
    </div>
